/* CreateComponent.js */

"use strict";
const BaseCreateComponent = require("../../../../../../lib/actions/components/create/BaseCreateComponent");

class CreateComponent extends BaseCreateComponent {
    constructor(logger, title, message, placeholder, value) {
        super(logger, title || "Create Template", message, "Enter Template Name", value);
    }
}

module.exports = CreateComponent;
